<div class="main-container">
  <form [formGroup]="form" class="d-flex flex-column justify-content-between form-container">
    <div class="row">
      <div class="col-12">
        <div class="input-container">
          <label class="label" for="Ownership">Assign Ownership</label>
          <div [ngClass]="{ 'invalid-input': form.get('ownership')?.invalid && form.get('ownership')?.touched }">
            <app-assigning-users-input formControlName="ownership"></app-assigning-users-input>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="input-container">
          <label class="label" for="status">Status</label>
          <div>
            <select name="" id="" class="input" formControlName="status">
              <option value="" hidden>-- select an option --</option>
              <option *ngFor="let item of status" [ngClass]="{'d-none': item.disabled}" [value]="item.name">{{item.name}}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="input-container">
          <label class="label">Priority</label>
          <div>
            <select name="" id="" class="input" formControlName="priority">
              <option value="" hidden>-- select an option --</option>
              <option *ngFor="let item of priorities" [value]="item.name">{{item.name}}</option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end">
      <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!checkAtLeastOneFieldSelected()">Reset</ion-button>
      <ion-button class="filled-blue-btn" [disabled]="!checkAtLeastOneFieldSelected()" (click)="onSubmit()">Apply</ion-button>
    </div>
  </form>
</div>